import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  cargoTypes,
  cargoQualityValues,
  cargoInvoiceStatusValues,
} from "dora-contracts";
import { trailerQualityValues } from "dora-contracts";
import { useAppDispatch, useSelector } from "../../../redux-store";
import { selectTeams } from "../../../ducks/data/teams/selectors";
import { loadTeams } from "../../../ducks/data/teams";

const useShipmentFormSelectOptions = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(loadTeams());
  }, [dispatch]);

  const teams = useSelector(selectTeams);
  const { t } = useTranslation("types");

  const cargoTypeAllOptions = useMemo(
    () =>
      cargoTypes.map((id) => ({
        value: id,
        label: t("cargoTypes.type", { context: id }),
      })),
    [t]
  );
  const cargoQualityAllOptions = useMemo(
    () =>
      cargoQualityValues.map((id) => ({
        id,
        label: t("cargoQualities.type", { context: id }),
      })),
    [t]
  );
  const trailerQualityAllOptions = useMemo(
    () =>
      trailerQualityValues.map((id) => ({
        id,
        label: t("trailerQualities.type", { context: id }),
      })),
    [t]
  );
  const cargoInvoiceStatusOptions = useMemo(
    () =>
      cargoInvoiceStatusValues.map((id) => ({
        value: id,
        label: t("cargoInvoiceStatus.type", { context: id }),
      })),
    [t]
  );
  const teamsOptions = useMemo(
    () =>
      teams.map((t) => ({
        label: t.name,
        value: t.id,
      })),
    [teams]
  );
  return {
    teamsOptions,
    trailerQualityAllOptions,
    cargoQualityAllOptions,
    cargoTypeAllOptions,
    cargoInvoiceStatusOptions,
  };
};

export default useShipmentFormSelectOptions;
